import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import { NotificationModal } from './NotificationModal';

interface NotificationIconProps {
  customSize?: number;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({ customSize = 20 }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label="Gameweek deadline reminders"
        className="relative inline-flex min-h-11 min-w-11 items-center justify-center rounded-full text-content hover:bg-content/10 transition-colors"
        onClick={() => setIsModalOpen(true)}
      >
        <Bell size={customSize} aria-hidden />
      </button>
      
      {isModalOpen && (
        <NotificationModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
        />
      )}
    </>
  );
};

